/**
 * @fileoverview POST handler for the "/alloys/partners/datadog/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAlloysPartnersDatadogAppGroupIdCacheKeys } from "./constants";
import type { PostAlloysPartnersDatadogAppGroupIdProps, PostAlloysPartnersDatadogAppGroupIdResult } from "./types";

export const postAlloysPartnersDatadogAppGroupId = reactQueryMutationAdapter(
  postAlloysPartnersDatadogAppGroupIdCacheKeys,
  (props: PostAlloysPartnersDatadogAppGroupIdProps): Promise<PostAlloysPartnersDatadogAppGroupIdResult> => {
    return fetch(
      `/alloys/partners/datadog/${props.appGroupId}`,
      "POST",
      {
        api_key: props.apiKey,
        ...(props.site != null && { site: props.site }),
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
